import { type FC, Fragment, useMemo } from 'react';
import type { PhraseAnonymizationTag } from '@/entities/conversations';
import { formatTextTypography } from '@/shared/lib';
import { AnonymizationTagBadge } from './AnonymizationTagBadge';
import { parsePhraseText } from './anonymizationTags';

type Props = {
  /** Текст реплики (в анонимизированном виде содержит теги подстановок) */
  text: string;
  /** Подстановки анонимизации, встречающиеся в тексте реплики */
  tags: PhraseAnonymizationTag[];
  className?: string;
};

/**
 * Текст реплики: обычные фрагменты — сплошным текстом, подстановки анонимизации — блоками.
 */
export const TranscriptPhraseText: FC<Props> = ({ text, tags, className }) => {
  const parts = useMemo(() => parsePhraseText(text, tags), [text, tags]);

  return (
    <p className={className}>
      {parts.map((part, index) =>
        part.kind === 'text' ? (
          <Fragment key={index}>{formatTextTypography(part.text)}</Fragment>
        ) : (
          <AnonymizationTagBadge key={index} label={part.marker.label} value={part.marker.value} />
        ),
      )}
    </p>
  );
};
